import styled from 'styled-components';
import tw from 'twin.macro';
import { motion } from 'framer-motion';
import SVGIcon from '../../components/SVGIcon/SVGIcon';
import { Body } from '../../styled components/Typography';

export const SubheaderAnimationContainer = styled(motion.div)(({ top }) => [
  'position: fixed;',
  'width: 100%;',
  `top: ${top}px;`,
  'z-index: 89;'
]);

export const SubHeaderItem = styled.li(
  ({ $marginBottom, $marginRight, $responsiveMargin }) => [
    tw`flex`,
    $marginBottom && tw`mb-4`,
    $marginRight && tw`mr-4`,
    $responsiveMargin && tw`md:mr-16`
  ]
);

export const SubHeaderMainItemIconContainer = styled.div(() => [
  tw`flex mr-4`,
  'padding-top: 0.125rem;'
]);

export const SubHeaderMainItemText = styled.span(() => [
  tw`min-w-0 text-sm text-black text-opacity-85 leading-20`
]);

export const SubHeaderIcon = styled(SVGIcon)(() => [tw`fill-blue-base opacity-95`]);

export const HeaderTitleButton = styled(Body).attrs(() => ({
  as: 'button',
  $textStyle: 'bold'
}))(() => [tw`inline-flex items-center justify-center w-full`]);

export const HeaderTitleButtonContent = styled.span(() => [tw`truncate`]);

export const HeaderTitleExpandIcon = styled(SVGIcon)(() => [tw`ml-4`]);
